import { useState } from "react";
import LoadComponent from "./steps/LoadComponent";
import { useProductSlice } from "./helpers/helpers";
import validateProductStep from "./validations/validateProductStep";
import ErrorPopup from "./components/ErrorPopup";
import HandleSteps from "./components/HandleSteps";

const Product = ({
  productType,
  step,
  t,
  isLoading,
  handlePrevStep,
  handleNextStep,
  profile,
  totalSteps,
  separatorOne,
  separatorTwo,
}) => {
  const productData = useProductSlice();
  const [popupError, setPopupError] = useState("");
  const [loading, setLoading] = useState(false);

  // console.log(separatorOne, separatorTwo)
  const handleVerify = () => {
    setLoading(true);
    const error = validateProductStep(productType, productData, step, t);

    if (error) {
      setLoading(false);
      setPopupError(error);
      return;
    }

    setLoading(false);
    handleNextStep();
  };

  if (loading)
    return (
      <div
        className="d-flex justify-content-center align-items-center"
        style={{ height: "300px" }}
      >
        <div className="loader" />
      </div>
    );

  return (
  <div className="d-flex flex-column " >
      {/* Main content - scrollable */}
      <main className="flex-grow-1">
       
          <form>
            <LoadComponent
              productType={productType}
              step={step}
              t={t}
              profile={profile}
              isLoading={isLoading}
              handlePrevStep={handlePrevStep}
              handleNextStep={handleNextStep}
            />
          </form>
        
      </main>

      {/* Navigation at the bottom */}
      <HandleSteps
        isLoadingbtn={loading || isLoading}
        totalSteps={totalSteps}
        step={step}
        prev={handlePrevStep}
        next={handleVerify}
        sepratorOne={separatorOne}
        SeparatorTwo={separatorTwo}
      />

      {/* Error Popup */}
      <ErrorPopup
        open={!!popupError}
        onClose={() => setPopupError("")}
        message={popupError}
      />
    </div>
  );
};

export default Product;
